export default __webpack_public_path__ + "static/media/LOGO_TECHBOARD.eaff5f3d.png";